"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ViewVisibleIcon = function ViewVisibleIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$filled = _ref.filled,
      filled = _ref$filled === void 0 ? false : _ref$filled,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["color", "size", "filled", "className", "children"]);

  var classes = 'calcite-icon';
  if (className) classes += " ".concat(className);

  if (size <= 16) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 16 16",
      className: classes
    }), filled ? _react["default"].createElement("path", {
      d: "M8 3.098c-3.068 0-5.763 2.39-7.613 4.901C2.237 10.51 4.925 12.9 8 12.9c3.068 0 5.763-2.39 7.613-4.901C13.763 5.488 11.075 3.098 8 3.098zm0 8.36c-2.623 0-4.976-2.336-5.956-3.46C3.021 6.873 5.366 4.54 8 4.54c2.623 0 4.976 2.335 5.956 3.46-.977 1.124-3.322 3.456-5.956 3.456zM8 10a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"
    }) : _react["default"].createElement("path", {
      d: "M15.896 7.195C15.765 7.024 12.624 3 8.56 3 4.5 3 1.247 7.017 1.11 7.188L.86 7.5l.25.312C1.245 7.982 4.497 12 8.558 12c4.065 0 7.206-4.024 7.337-4.195l.235-.305zM8.56 11.1c-3.045 0-5.73-2.663-6.58-3.6.85-.937 3.535-3.6 6.58-3.6 3.049 0 5.655 2.672 6.47 3.6-.813.93-3.414 3.6-6.47 3.6zm-.06-6a2.4 2.4 0 1 0 2.4 2.4 2.402 2.402 0 0 0-2.4-2.4z"
    }));
  }

  if (size <= 24) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 24 24",
      className: classes
    }), filled ? _react["default"].createElement("path", {
      d: "M12.5 19.9c-6.068 0-10.868-6.81-11.07-7.058l-.277-.341.277-.342C1.632 11.91 6.432 5.1 12.5 5.1s10.868 6.81 11.07 7.059l.277.342-.277.341c-.202.249-5.002 7.058-11.07 7.058zm9.111-7.4c-1.617-1.96-5.154-5.6-9.111-5.6s-7.494 3.64-9.111 5.6c1.617 1.96 5.155 5.6 9.111 5.6s7.494-3.64 9.111-5.6zM12.5 9.1a3.4 3.4 0 1 0 3.4 3.4 3.4 3.4 0 0 0-3.4-3.4z"
    }) : _react["default"].createElement("path", {
      d: "M22.9 11.201C22.712 10.948 18.208 5 12.5 5S2.288 10.948 2.1 11.201l-.224.299.224.299C2.288 12.052 6.792 18 12.5 18s10.212-5.948 10.4-6.201l.224-.299zM12.5 17.1c-4.59 0-8.532-4.39-9.53-5.6.998-1.21 4.94-5.6 9.53-5.6s8.532 4.39 9.53 5.6c-.998 1.21-4.94 5.6-9.53 5.6zm0-9a3.4 3.4 0 1 0 3.4 3.4 3.404 3.404 0 0 0-3.4-3.4z"
    }));
  }

  return _react["default"].createElement("svg", _extends({}, props, {
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 32 32",
    className: classes
  }), filled ? _react["default"].createElement("path", {
    d: "M16.456 24.9c-8.153 0-14.579-8.343-14.848-8.698l-.532-.702.532-.702c.27-.355 6.695-8.698 14.848-8.698s14.579 8.343 14.848 8.698l.532.702-.532.702c-.27.355-6.695 8.698-14.848 8.698zm13.278-9.4c-1.512-1.788-6.96-7.658-13.278-7.658S4.691 13.712 3.178 15.5c1.512 1.788 6.96 7.657 13.278 7.657S28.221 17.29 29.734 15.5zm-7.834 0a5.4 5.4 0 1 1-5.4-5.4 5.4 5.4 0 0 1 5.4 5.4z"
  }) : _react["default"].createElement("path", {
    d: "M16.5 8C9.044 8 3 15.5 3 15.5S9.044 23 16.5 23 30 15.5 30 15.5 23.956 8 16.5 8zm0 14.1c-5.751 0-10.727-4.831-12.356-6.599C5.776 13.733 10.764 8.9 16.5 8.9c5.751 0 10.727 4.831 12.356 6.6-1.632 1.767-6.62 6.6-12.356 6.6zm0-2.2a4.4 4.4 0 1 1 4.4-4.4 4.405 4.405 0 0 1-4.4 4.4z"
  }));
};

var _default = ViewVisibleIcon;
exports["default"] = _default;